export enum ChangeSummaryRowType {
  SECTION = 'SECTION',
  HEADING = 'HEADING',
  CLAUSE = 'CLAUSE',
}
